// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__1oxVZ","container":"styles_container__lJqRu","close":"styles_close__2xgPt"};